//Defining headers for use on action dropdown menus.

//Workspace action headers.
export enum WorkspaceActionHeader {
  GENERAL = 'General',
  PROCESS_ORDERS = 'Process Orders',
  MAXOPTRA = 'Maxoptra',
  STATUS_UPDATE = 'Status Update',
  REPORTS = 'Reports',
}

//Workaround for difficulties with iterating over TypeScript enums.
export const workspaceActionHeaderForEach = (func: (header: WorkspaceActionHeader) => void) => {
  func(WorkspaceActionHeader.GENERAL);
  func(WorkspaceActionHeader.PROCESS_ORDERS);
  func(WorkspaceActionHeader.MAXOPTRA);
  func(WorkspaceActionHeader.STATUS_UPDATE);
  func(WorkspaceActionHeader.REPORTS);
};
